import React, { useState } from 'react';
import { useFormContext, Controller } from 'react-hook-form';
import { get } from 'lodash';
import { ChevronDown, ChevronUp } from 'lucide-react';
import CurrencyInput from '../../../../../components/CurrencyInput';

import { OrderSchemaType } from '../order.schema';
import { useOrderCalculations } from '../Hooks/useOrderCalculations';

import {
  Title,
  FormGrid,
  FormGroup,
  Label,
  Input,
  CollapsibleHeader,
  CircularCollapseIcon,
  Separator,
  Summary,
  SummaryItem,
  SummaryLabel,
  SummaryValue,
} from '../style';

import SteelOrdersInfiniteSelect from '../components/SteelOrdersInfiniteSelect';

const FreteSection: React.FC = () => {
  const [isOpen, setIsOpen] = useState(true);

  const { control, register, watch, setValue, formState: { errors } } = useFormContext<OrderSchemaType>();

  const { totalQuantity, taxes, total } = useOrderCalculations();

  return (
    <>
      <CollapsibleHeader onClick={() => setIsOpen(prev => !prev)}>
        <Title>Frete</Title>
        <CircularCollapseIcon onClick={(e) => { e.stopPropagation(); setIsOpen(prev => !prev); }}>
          {isOpen ? <ChevronUp size={24} /> : <ChevronDown size={24} />}
        </CircularCollapseIcon>
      </CollapsibleHeader>

      {isOpen && (
        <>
          <FormGrid>
            <FormGroup style={{ position: 'relative' }}>
              <Controller
                name="shippingTypeId"
                control={control}
                render={({ field }) => (
                  <SteelOrdersInfiniteSelect
                    label="Tipo de Frete"
                    endpoint="shipping-types"
                    items={field.value ? [{ id: field.value, name: watch('shippingTypeName') || 'Selecionado' }] : []}
                    setItems={(newItems: any) => {
                      field.onChange(newItems.length > 0 ? newItems[0].id : undefined);
                      setValue('shippingTypeName', newItems.length > 0 ? newItems[0].name : undefined, { shouldDirty: true });
                    }}
                    placeholder="Selecione"
                    searchPlaceholder="Buscar tipo..."
                  />
                )}
              />
            </FormGroup>

            <FormGroup>
              <Label htmlFor="shippingValue">Valor do Frete</Label>
              <Controller
                name="shippingValue"
                control={control}
                render={({ field }) => (
                  <CurrencyInput
                    id="shippingValue"
                    name={field.name}
                    value={field.value || 0}
                    onValueChange={(value, name, values) => {
                      field.onChange(values?.float || 0);
                    }}
                    placeholder="R$ 0,00"
                    hasError={!!get(errors, 'shippingValue')}
                  />
                )}
              />
            </FormGroup>

            <FormGroup>
              <Label>Código de rastreio</Label>
              <Input {...register('trackingCode')} placeholder="Digite" />
            </FormGroup>
          </FormGrid>
        </>
      )}

      <Separator />

      <Summary>
        <SummaryItem>
          <SummaryLabel>Quantidade total:</SummaryLabel>
          <SummaryValue>{totalQuantity || 0}</SummaryValue>
        </SummaryItem>
        <SummaryItem>
          <SummaryLabel>Tributos:</SummaryLabel>
          <SummaryValue>
            {(taxes || 0).toLocaleString('pt-BR', {
              style: 'currency',
              currency: 'BRL',
            })}
          </SummaryValue>
        </SummaryItem>
        <SummaryItem>
          <SummaryLabel>Total:</SummaryLabel>
          <SummaryValue>
            {(total || 0).toLocaleString('pt-BR', {
              style: 'currency',
              currency: 'BRL',
            })}
          </SummaryValue>
        </SummaryItem>
      </Summary>
    </>
  );
};

export default FreteSection;
